import React, { FC } from 'react';
import { connect } from 'react-redux';
import { getProductionBatchByProductionOperationId, operationsSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { useRoute } from '@react-navigation/native';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useJobDetails } from '@v2/pages/common/hooks/useJobDetails';
import { getNCFilesByProductionOperationId } from '@reducers/manufacture';
import { loadSingleBatch } from '@reducers/batch';
import { SingleBatchOrBatchList } from '@v2/pages/common/components/SingleBatchOrBatchList/SingleBatchOrBatchList';
import { LoadSingleBatch } from '@interfaces/methods';
import JobContentWrapper from '@v2/pages/job/common/components/JobContentWrapper';
import { parseRouteParamAsNumber } from '@helpers';

interface JobDetailsBatchProps {
  loadSingleBatch: LoadSingleBatch;
}

const JobDetailsBatchComponent: FC<JobDetailsBatchProps> = ({
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
  loadSingleBatch,
}) => {
  const title = useTitle();
  const route = useRoute();

  const jobId = parseRouteParamAsNumber(route.params?.productionOperationId);

  useJobDetails({
    operationsSearch,
    updateHeaderConfig,
    getNCFilesByProductionOperationId,
    getProductionBatchByProductionOperationId,
    loadSingleBatch,
  });

  return (
    <JobContentWrapper loading={false} title={title.batch}>
      <SingleBatchOrBatchList fetchBatchList={getProductionBatchByProductionOperationId} idForGettingBatchList={jobId} />
    </JobContentWrapper>
  );
};

const JobDetailsBatch = connect(null, {
  operationsSearch,
  updateHeaderConfig,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
  loadSingleBatch,
})(JobDetailsBatchComponent);

export { JobDetailsBatch };
